<template>
    <div class="inner-wrapper">
        <!--<div class="page-title" style="width:100%">
            <div class="title-right float-right">
                <div class="btnrow float-right">
                    <a href="javascript:void(0)" data-toggle="modal" data-target="#addReminderModal" class="btn create-btn">
                        <i  class="ri-add-circle-line align-bottom me-1"></i> Add Reminder
                    </a>
                </div>
            </div>
        </div>-->
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-auto">
                                <form class="form-inline list-search" action="">
                                    <div class="filter-sec">
                                        <button type="button" class="btn filter-btn" @click="toggleShowFilters">
                                            <i class="ri-filter-line align-bottom me-1"></i> Filters
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div class="col-lg-3 col-auto">
                                <form class="form-inline list-search" @submit.prevent="search(1)">

                                    <div class="input-group">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" @click.prevent="search"><i class="ri-search-line search-icon"></i></button>
                                        </div>
                                        <input v-model="filterForm.search_filter" type="text" class="form-control"
                                               placeholder="Quick Search">

                                    </div>

                                </form>
                            </div>
                            <div class="col-auto ms-sm-auto">
                                <div class="btnrow float-right">
                                    <div class="d-flex align-items-center">
                                        <a href="javascript:void(0)" data-toggle="modal" data-target="#addReminderModal" class="btn create-btn">
                                            <i  class="ri-add-circle-line align-bottom me-1"></i> Add Reminder
                                        </a>
                                        <div class="quotes-text">{{ total }} Reminders</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filter-row" v-if="showFilters">
                            <div class="form-group">
                                <select class="form-control" v-model="filterForm.status" @change="search(2)">
                                    <option :value="null">All</option>
                                    <option value="0">Open</option>
                                    <option value="1">Completed</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <v-select label="text" :filterable="true" placeholder="User"
                                          v-model="filterForm.user_id"
                                          :options="admins">
                                    <template slot="no-options">
                                        type to search admins..
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.name">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.name">
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="search-btnsec dl-flex">
                                <button class="btn btn-success" type="button" @click.prevent="search(2)"><i class="ri-search-line search-icon"></i>
                                </button>
                                <button class="btn btn-reset" type="button" @click="resetFilter"><i class="ri-refresh-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>


            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="card panel ">
                        <!--<div class="card-header headnbtn">
                            <div  class="d-flex align-items-center justify-content-between">
                                <h5  class="card-title mb-0 flex-grow-1">Reminders</h5>
                            </div>
                        </div>-->
                        <div class="card-body p-0" v-if="reminderData.reminders">
                            <div class="table-responsive product-create mb-0">
                                <table class="table table-custom table-nowrap table-bordered align-middle mb-0">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Assigned to</th>
                                        <th>Due Date</th>
                                        <th>Priority</th>
                                        <th style="width: 80px">Action </th>
                                    </tr>
                                    </thead>
                                    <tr v-for="(reminder, index) in reminderData.reminders.data" :key="reminder.id" :id="reminder.id">
                                        <td class="t-sts">
                                            <template v-if="reminder.status == 1 || reminder.status == '1'">
                                                <i class="fa fa-check-circle" style="color: green;" ></i>
                                            </template>
                                            <template v-else> <i class="fa fa-check-circle"></i></template>
                                            <a href="javascript:void(0)" @click="viewReminder(reminder)">
                                                <template v-if="reminder.status === 0 && enableAction">
                                                    <template v-if="reminder.title === 'Create PO'">
                                                        <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-purchase-order')">
                                                            <a href="javascript:void(0);" @click="createPO(reminder)">{{reminder.title}}</a>
                                                        </template>
                                                        <template v-else> {{reminder.title}}</template>
                                                    </template>
                                                    <template v-else> {{reminder.title}}</template>
                                                </template>
                                                <template v-else>
                                                    {{ reminder.title }}
                                                </template>
                                            </a>
                                        </td>
                                        <td>
                                            <template v-for="(admin, adminIndex) in reminder.admins">
                                                <template v-if="adminIndex > 0">, </template>{{admin.name}}
                                            </template>
                                        </td>

                                        <td>
                                            <template v-if="reminder.status == 1 || reminder.status == '1'">
                                                Completed at {{formatDate(reminder.completed_at)}}
                                            </template>
                                            <template v-else>
                                                {{formatDate(reminder.due_date)}} <span class="text-danger">{{getTimeAgo(reminder.due_date)}}</span>
                                            </template>
                                        </td>
                                        <td><span class="badge" :class="nameToCSSClass(reminder.priority.priority_name, 'badge-soft-')" v-if="reminder.priority">{{reminder.priority.priority_name}}</span></td>
                                        <td>
                                            <a href="javascript:void(0)" @click="editReminder(reminder)" class="edit_btn" title="Edit Reminder"><i class="ri-edit-fill me-1"></i></a>
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>

                        <div class="btnrow text-left mb-3">
                            <template v-if="reminderData.reminders != null && reminderData.reminders.data.length">
                                <div class="overflow-auto">
                                    <b-pagination
                                        v-model="current_page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" style="padding: 0.75rem 0.85rem;">No records found!</td>
                                </tr>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <AddReminder :reminder="reminder" :quotation="quotation" :user="getAuthUser" @addedEvent="reminderAddedEvent" @updatedEvent="reminderUpdatedEvent"></AddReminder>
        <ViewReminder :reminder="reminder" :quotation="null" @openEditEvent="editReminder" @reminderCompletedEvent="reminderCompletedEvent"></ViewReminder>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import AddReminder from "../../components/AddReminder";
import moment from "moment";
import axios from "axios";
import {debounce} from "lodash";
import ViewReminder from "../../components/ViewReminder";

export default {
    name: "Reminders",
    components: {AddReminder, ViewReminder},
    created() {

    },
    mounted() {
        this.getReminderSettings();
        this.getReminders();
        let self = this;
        $('#addReminderModal').on('hidden.bs.modal', function () {
            self.reminder = null;
            self.quotation = null;
        });
    },
    data(){
        return {
            enableAction: false,
            reminder: null,
            current_page:1,
            per_page:5,
            total:0,
            admins: [],
            filterForm: {
                search_filter: null,
                status: 0,
                user_id: null,
                quotation_id: null
            },
            reminderData: {
                reminders: null,
                can_add_reminder: false,
                can_edit_reminder: false,
                can_delete_reminder: false,
                role: null,
                admin: null
            },
            showFilters: false,
            filters: {
                statuses: [],
                sale_users: [],
                admin_users: [],
            },
            orders: [],
            quotation: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setCustomerLoading',
            'setReminderFilterData',
            'setReminderShowFilters',
            'setNewPurchaseOrder'
        ]),
        resetFilter() {
            this.filterForm = {
                search_filter: null,
                status: 0,
                user_id: null,
                quotation_id: null
            };

            this.setReminderFilterData(this.filterForm);
            this.search();
        },
        toggleShowFilters(){
            this.showFilters = !this.showFilters;
            this.setReminderFilterData(this.showFilters);
        },
        search(buttonIndex) {
            if(buttonIndex === 1) {
                this.getReminders();
            } else {
                this.getReminders();
            }
        },
        getTimeAgo(datetime) {
            return moment(datetime).fromNow();
        },
        viewReminder(reminder) {
            this.reminder = _.cloneDeep(reminder);
            if(reminder.quotation) {
                let name  = '#' + reminder.quotation.quotation_number;
                if(reminder.quotation.quote_name && reminder.quotation.quote_name !== '') {
                    name += ` (${reminder.quotation.quote_name})`;
                }
                reminder.quotation.name = name;
                reminder.quotation.text = name;
                reminder.quotation.html = name;
                this.quotation = _.cloneDeep(reminder.quotation);
            }
            setTimeout(() => {
                $('#viewReminderModal').modal('show');
            }, 100);
        },
        editReminder(reminder) {
            this.reminder = _.cloneDeep(reminder);
            if(reminder.quotation) {
                let name  = '#' + reminder.quotation.quotation_number;
                if(reminder.quotation.quote_name && reminder.quotation.quote_name !== '') {
                    name += ` (${reminder.quotation.quote_name})`;
                }
                reminder.quotation.name = name;
                reminder.quotation.text = name;
                reminder.quotation.html = name;
                this.quotation = _.cloneDeep(reminder.quotation);
            }

            $('#viewReminderModal').modal('hide');

            setTimeout(() => {
                $('#addReminderModal').modal('show');
            }, 100);
        },
        reminderAddedEvent(event){
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        reminderUpdatedEvent(event){
            this.reminder = null;
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        reminderCompletedEvent(event) {
            this.getReminders();
        },
        getReminders() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('dashboard.reminders.index', {
                search_filter: this.filterForm.search_filter,
                user_id: this.filterForm.user_id,
                status: this.filterForm.status,
                quotation_id: this.filterForm.quotation_id,
                page: this.current_page,
            }), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.reminderData.reminders = data.data;

                        //this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;

                        this.reminderData.admin = data.extra.admin;
                        this.reminderData.role = data.extra.role;
                        this.reminderData.can_add_reminder = data.extra.can_add_reminder;
                        this.reminderData.can_delete_reminder = data.extra.can_delete_reminder;
                        this.reminderData.can_edit_reminder = data.extra.can_edit_reminder;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteReminder() {
            if(this.deleteId) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('dashboard.reminders.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.getReminders();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        },
        getReminderSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.tasks.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.admins = _.cloneDeep(data.data.admins);
                        //this.priorities = _.cloneDeep(data.data.priorities);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
    },
    computed: {
        ...mapGetters([
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
            'getAuthUser',
        ])
    },
    watch: {
        current_page: {
            handler: function (value) {
                this.getReminders();
            }
        },
        'filterForm.status': {
            handler: function (value) {
                this.getReminders();
            }
        },
        'filterForm.user_id': {
            handler: function (value) {
                this.getReminders();
            }
        },
    }
}
</script>

<style scoped>

</style>
